import React, { useContext, useEffect, useState } from 'react';

import Loader from '#/components/Loader';
import AccordionBody from '#/components/Accordion/AccordionBody';
import AccordionItem from '#/components/Accordion/AccordionItem';

import barIcon from '#/assets/icons/bar-chart.svg';
import pieIcon from '#/assets/icons/pie-chart.svg';
import listIcon from '#/assets/icons/list-chart.svg';
import percentIcon from '#/assets/icons/percent-chart.svg';
import labelValueIcon from '#/assets/icons/labelValue-chart.svg';
import { fetchWidgets,fetchDashBoardSharedModel,findDashboardById } from '#/api/widgetService';
import Modal from '#/components/Modal';
import useModal from '#/hooks/useModal';
import DashboardContext from '#/context';
import styles from './styles.module.css';
import detailsTable from '#/assets/icons/detailsTable.svg';

import { SelectedItemsProvider } from '#/providers/selectedItemsProvider';
import MultiSelectStatic from '#/components/MultiSelectStatic/index';


import {useTabs} from '#/contexts/tabscontexts';

import { useTranslation } from "react-i18next";


const icons = {
  pieChart: pieIcon,
  barChart: barIcon,
  percentChart: percentIcon,
  labelValue: labelValueIcon,
  basicList: listIcon,
  detailsTable: detailsTable
};

function WidgetBoard() {
  const {
    widgets,
    setLoading,
    setWidgets,
    stateDashboard, 
    setStateDashboard,
    tempDashboard,
  } = useContext(DashboardContext);


  const {activeTabIndex, handleNewTab} = useTabs();

  const [boardItens, setBoardItens] = useState([]);
  const { modal, toggleModal } = useModal();

  const { t } = useTranslation();

  useEffect(() => {
    const temp =
      (tempDashboard[activeTabIndex] &&
        tempDashboard[activeTabIndex].widgets) ||
      [];
    const actives = [
      ...temp.map(widget => {
        return { ...widget, active: false };
      }),
    ];
    concatItens(actives);
  }, [activeTabIndex, tempDashboard]);

  async function concatItens(actives) {
    try {
      const { data } = await fetchWidgets();
      setWidgets(data);
      setBoardItens(data);
    } catch ({ response }) {
      if (response.status === 401) {
        return toggleModal(
          t('SESSION_HAS_BEEN_EXPIRED')
        );
      }
      toggleModal(
        t('CANNOT_RETRIEVE_WIDGETS')
      );
    }
  }

  function handleDragStart(e) {
    const target = e.target.getAttribute('datakey');
    e.dataTransfer.setData('Text', target);
  }

  function handleItemSelected(item){
    setLoading(true);
    findDashboardById(item.value)
      .then((dashboard) => {
        item.widgets = dashboard.data;
        handleNewTab(item);
        setLoading(false);
      });
  }


  return (
    <React.Fragment>
      <Modal
        title={t('SOMETHING_WENT_WRONG')}
        isOpen={modal.isOpen}
        onClose={() => {
          toggleModal();
          setStateDashboard({ ...stateDashboard, edit: false });
        }}
      >
        {modal.message}
      </Modal>
      <div
        className={[styles.block, stateDashboard.board && styles.show].join(
          ' '
        )}
      >
        <button
          onClick={() =>
            setStateDashboard(stateDashboard => ({
              ...stateDashboard,
              board: !stateDashboard.board,
            }))
          }
          className={styles.addWidget}
          data-testid="open-board-button"
        >
          <span
            className={[
              styles.menuIcon,
              !stateDashboard.board && styles.iconOpen,
            ].join(' ')}
          />
        </button>
        {widgets.length ? (
          <div
            className={[styles.board, stateDashboard.board && styles.show].join(
              ' '
            )}
          >

            <AccordionBody>
              <AccordionItem title={t('SHARED_TEMPLATES')} isOpened={true} hideToggle>
              
                <SelectedItemsProvider>
                  <MultiSelectStatic 
                    placeHolder={`${t('SELECT')}...`}
                    selectedItems={[]}
                    onSelect={(item) =>{handleItemSelected(item)}}
                    isMultiple={false}
                    closeOnSelect={true}
                    fetchItems={fetchDashBoardSharedModel}
                  />
                </ SelectedItemsProvider>
              </AccordionItem>
              <AccordionItem title={t('WIDGETS')}>
                <ul className={styles.listWidget}>
                  {boardItens.map(widget => {
                    return (
                      <li
                        key={widget.tmpKey}
                        datakey={widget.i}
                        className={[
                          styles.widget,
                          widget.active && styles.active,
                        ].join(' ')}
                        onDragOver={event => event.preventDefault()}
                        onDragStart={handleDragStart}
                        draggable={!widget.active}
                      >
                        <img
                          src={icons[widget.type] || null}
                          alt={t('WIDGET_ICON')}
                          className={styles.icon}
                          draggable={false}
                        />
                        <span>
                          <h3>{widget.title}</h3>
                          <p>{widget.description}</p>
                        </span>
                      </li>
                    );
                  })}
                </ul>
              </AccordionItem>
            </AccordionBody>
          </div>
        ) : (
            <Loader shape="content" />
          )}
      </div>
    </React.Fragment>
  );
}

export default WidgetBoard;
